import {css} from '@emotion/css';
import {CustomerItem, customerItemPreviousResaleTypeBadge, Options} from '@remoov/functional';
import {CustomerPortalModalConfirmed, theme} from '@remoov/remoov-components';
import React from 'react';
import {AuctionBoardItem} from '../AuctionBoardItem';
import {
  ItemsBoardContainer,
  ItemsBoardHeader,
  ItemsBoardLeftContainer,
  ItemsBoardRightContainer,
  ItemsBoardRow,
  ItemsBoardRowWithActionIcon,
  ItemsBoardTitle,
} from '../Common';
import {ItemDetailsModal} from '../ItemDetailsModal';
import downArrow from './downarrow.svg';
import help from './help.svg';
import upArrow from './uparrow.svg';

export type AuctionBoardProps = {
  items: CustomerItem[];
  originalItems: CustomerItem[];
  categories: Options<number>;
  isOpenModal: Maybe<number>;
  setIsOpenModal: (itemId: Maybe<number>) => unknown;
  sort: string;
  sortDirection: 'asc' | 'desc';
  setSort: (column: string) => unknown;
  setStatusModal: () => unknown;
  setPublicNotes: (itemId: Maybe<number>) => (value: string) => unknown;
  savePublicNotes: (item: CustomerItem) => unknown;
  isSaveNotesModal: Maybe<number>;
  setIsSaveNotesModal: (itemId: Maybe<number>) => unknown;
};

export const AuctionBoard = ({
  items,
  originalItems,
  categories,
  isOpenModal,
  setIsOpenModal,
  sort,
  sortDirection,
  setSort,
  setStatusModal,
  setPublicNotes,
  savePublicNotes,
  isSaveNotesModal,
  setIsSaveNotesModal,
}: AuctionBoardProps) => (
  <ItemsBoardContainer>
    <ItemsBoardHeader>
      <ItemsBoardLeftContainer
        className={css({marginLeft: '194px', padding: `${theme.spacings.xsmall} 0`})}
      >
        <ItemsBoardRowWithActionIcon
          className={css({maxWidth: '100px'})}
          onClick={() => setSort('barcode')}
        >
          <ItemsBoardTitle>ID</ItemsBoardTitle>
          {sort !== 'barcode' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('description')}>
          <ItemsBoardTitle>DESCRIPTION</ItemsBoardTitle>
          {sort !== 'description' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
      </ItemsBoardLeftContainer>
      <ItemsBoardRightContainer className={css({margin: `${theme.spacings.xsmall} 0`})}>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('quantity')}>
          <ItemsBoardTitle>QUANTITY</ItemsBoardTitle>
          {sort !== 'quantity' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRowWithActionIcon>
          <ItemsBoardTitle onClick={() => setSort('status')}>STATUS</ItemsBoardTitle>
          {sort !== 'status' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
          <img src={help} alt='help icon' onClick={setStatusModal} />
        </ItemsBoardRowWithActionIcon>
        <ItemsBoardRow>
          <ItemsBoardTitle>SALES PRICE</ItemsBoardTitle>
        </ItemsBoardRow>
        <ItemsBoardRowWithActionIcon onClick={() => setSort('end_of_consignment')}>
          <ItemsBoardTitle>EXPIRES ON</ItemsBoardTitle>
          {sort !== 'end_of_consignment' ? null : sortDirection === 'asc' ? (
            <img src={upArrow} alt='crescent sort' />
          ) : (
            <img src={downArrow} alt='decrescent sort' />
          )}
        </ItemsBoardRowWithActionIcon>
      </ItemsBoardRightContainer>
    </ItemsBoardHeader>
    {items.map(item => (
      <React.Fragment key={`${item.id}-${item.status}`}>
        <AuctionBoardItem
          item={item}
          originalItem={originalItems.find(i => i.id === item.id) || item}
          resaleTypeBadge={customerItemPreviousResaleTypeBadge('auction', item.status)}
          itemDetailsClick={() => setIsOpenModal(item.id)}
          setPublicNotes={setPublicNotes(item.id)}
          savePublicNotes={() => savePublicNotes(item)}
        />
        {isOpenModal === item.id && (
          <ItemDetailsModal
            isOpen={isOpenModal === item.id}
            setIsOpen={newIsOpen => (newIsOpen ? setIsOpenModal(item.id) : setIsOpenModal(null))}
            code={item.barcode || ''}
            imgUrl={item.big_url || ''}
            imgAlt={item.material || ''}
            category={categories.find(({value}) => value === item.item_category_id)?.label || ''}
            brand={item.brand || ''}
            original_price={item.original_price || ''}
          />
        )}
        {isSaveNotesModal === item.id && (
          <CustomerPortalModalConfirmed
            isOpen={isSaveNotesModal === item.id}
            setIsOpen={newIsOpen =>
              newIsOpen ? setIsSaveNotesModal(item.id) : setIsSaveNotesModal(null)
            }
            title='Save Notes'
          >
            Your notes have been saved!
          </CustomerPortalModalConfirmed>
        )}
      </React.Fragment>
    ))}
  </ItemsBoardContainer>
);
